import {RuntimeType} from './RuntimeType';

const applicationTypes = {
  OPEN_VX_APP: 'OpenVX',
  PY_PICASSO_APP: 'PyPicasso',
  NATIVE_PYTHON: 'Python',
  CVEDIA_RT_APP: 'CVEDIA-RT',
  ONNX_WEB_APP: 'ONNX Web',
};

export type ApplicationType = keyof typeof applicationTypes;

export function getApplicationType(runtimeType?: RuntimeType): ApplicationType | null {
  if (!runtimeType) {
    return null;
  }
  switch (runtimeType) {
    case 'OPENVX':
      return 'OPEN_VX_APP';
    case 'ONNX_RUNTIME_WEB':
      return 'ONNX_WEB_APP';
    case 'PY_PICASSO':
      return 'PY_PICASSO_APP';
    case 'OPENCV_PYTHON':
      return 'NATIVE_PYTHON';
    case 'CVEDIA_RT':
      return 'CVEDIA_RT_APP';
    default:
      return null;
  }
}
